//Type de champs reconnus
export var fieldsType;
(function (fieldsType) {
    fieldsType["address"] = "address";
    fieldsType["base"] = "base";
    fieldsType["bool"] = "bool";
    fieldsType["date"] = "date";
    fieldsType["datetime"] = "datetime";
    fieldsType["email"] = "email";
    fieldsType["enum"] = "enum";
    fieldsType["multienum"] = "multienum";
    fieldsType["id"] = "id";
    fieldsType["link"] = "link";
    fieldsType["name"] = "name";
    fieldsType["radio"] = "radio";
    fieldsType["relate"] = "relate";
    fieldsType["text"] = "text";
    fieldsType["phone"] = "phone";
    fieldsType["url"] = "url";
    fieldsType["file"] = "file";
    fieldsType["currency"] = "currency";
    fieldsType["parent"] = "parent";
    fieldsType["facelift"] = "facelift";
    fieldsType["function"] = "function";
    fieldsType["password"] = "password";
})(fieldsType || (fieldsType = {}));
